module.exports = __webpack_public_path__ + "img/banner.c643f19e.webp";